<template>
  <div>
    <div class="btn_outer_container">
      <div class="btn_container" v-for="(item, i) in items" :key="i">
        <v-btn
          text
          class="btn_class"
          height="40"
          :class="value == i ? 'btn_active_class' : 'btn_no_active_class'"
          @click="value = i"
        >
          <span>{{ item.label }}</span>
        </v-btn>
        <div class="vertical_line" v-if="items.length - 1 !== i"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SearchPageTabs",
  props: {
    items: {
      required: true,
      type: Array,
    },
    value: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    value(value) {
      this.$emit("input", value);
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.btn_outer_container {
  display: flex;
  border: 1px solid #e3e3e3;
  border-radius: 11px;
  padding: 3px;
  background: #fff;
}
.btn_container {
  flex: 1;
  display: flex;
}
.btn_class {
  text-transform: capitalize;
  letter-spacing: 0px;
  width: 90%;
  z-index: 2 !important;
}
.btn_no_active_class {
  border-radius: 10px;
  background: #fff;
}
.btn_no_active_class >>> span {
  color: rgba(51, 51, 51, 0.74);

  text-align: center;
  font-family: Avenir;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.btn_active_class {
  border-radius: 8px;
  background: #d5e8ff;
}
.btn_active_class >>> span {
  color: #2d8cff;

  text-align: center;
  font-family: Avenir;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.vertical_line {
  border-radius: 10px;
  background: #e3e3e3;
  height: 25px;
  width: 2px;
  margin-top: 6px;
  margin-left: 6px;
}
</style>
